// extracted by mini-css-extract-plugin
export default {"whiteBoard":"index_whiteBoard__2exQ3"};